import { RequestErrorPlaceholder } from "designSystem/index";
import React from "react";

export default () => {
	const onRetryFunction = () => {
		console.debug("Retry..");
	};

	return (
		<RequestErrorPlaceholder
			buttonRes="Request Error Button"
			onRetry={onRetryFunction}
			subtitleRes="Request Error subtitle"
			titleRes="Request Error title"
		/>
	);
};
